<template>
  <div class="radio-icon">
    <span class="custom-radio">
      <span class="outer-circle">
        <span class="inner-circle" :class="{ active: active }"></span>
      </span>
    </span>
  </div>
</template>
<script>
export default {
  name: 'RadioIcon',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss">
.radio-icon {
  width: 20px;
  height: 20px;
  .custom-radio {
    width: 20px;
    height: 20px;
    position: relative;

    .outer-circle {
      width: 100%;
      height: 100%;
      border: 2px solid var(--primary);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .inner-circle {
      width: 12px;
      height: 12px;
      border: 2px solid var(--primary);
      border-radius: 50%;
      transition: 0.4s;

      &.active {
        background: var(--primary);
      }
    }
  }
}
</style>
